var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-page',[_c('div',[(_vm.loading)?_c('div',[_c('generic-loading')],1):_c('div',[_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.creatorVideos),function({ creatorVideo }){return _c('b-list-group-item',{key:creatorVideo.id,attrs:{"action":""},on:{"click":function($event){return _vm.$router.push({
                            name: 'videoView',
                            params: {
                                id: creatorVideo.id,
                            },
                        })}}},[_c('video-avatar',{attrs:{"creatorVideo":creatorVideo}})],1)}),1)],1)]),_c('generic-pagination',{attrs:{"hasMorePages":_vm.hasMorePages,"page":_vm.page},on:{"next":_vm.next,"previous":_vm.previous}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }